// © Microsoft Corporation. All rights reserved.

export const MY_REACTIONIDS = "myReactionIds";
export const MY_REACTION_PREFIX = "myReaction";